import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import AdminNavbar from "../components/AdminNavbar";
import { motion } from "framer-motion"; // 👈 import framer-motion

const UserOperations = () => {
  const { userId } = useParams();
  const location = useLocation();
  const userName = location.state?.userName || "User";

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCompletedTasks = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.get(`/admin/completedTasks/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTasks(response.data.tasks);
      } catch (err) {
        setError(err.response?.data?.error || "Failed to fetch completed tasks.");
      } finally {
        setLoading(false);
      }
    };

    fetchCompletedTasks();
  }, [userId]);

  const columns = [
    {
      name: "Task Name",
      selector: (row) => row.task_name,
      sortable: true,
    },
    {
      name: "Completed Date",
      selector: (row) => row.completed_date,
      sortable: true,
    },
  ];

  return (
    <div>
      <AdminNavbar />

      <motion.div
        className="container mt-5"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.h2
          className="mb-4 text-center"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          {userName}'s Completed Tasks
        </motion.h2>

        {error && (
          <motion.div
            className="alert alert-danger"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            {error}
          </motion.div>
        )}

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <DataTable
            columns={columns}
            data={tasks}
            progressPending={loading}
            pagination
            highlightOnHover
            responsive
            striped
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default UserOperations;
